// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"6df01268","344":"5aecb188","375":"8917bb32","653":"1ba46740"}[chunkId] + ".chunk.css";
};